let warnedMissing = false;

export function hasTransientActivation(): boolean {
    const activation: UserActivation | undefined = navigator.userActivation;
    if (activation === undefined) {
        if (!warnedMissing) {
            warnedMissing = true;
            console.warn(
                '[apps] navigator.userActivation is unavailable in this browser, so widget requests that need a user gesture are refused.',
            );
        }
        return false;
    }
    return activation.isActive;
}
